function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { setNodeOriginExpand, removeNodeOriginExpand, getNodeOriginParent } from '../utils';
export default {
  methods: {
    filter: function filter(value) {
      var nodesMap = this.treeStore.nodesMap,
          searchFilter = this.searchFilter;
      var filterNodes = [];
      var keys = Object.keys(nodesMap);

      for (var i = 0, l = keys.length; i < l; i += 1) {
        var node = nodesMap[keys[i]];

        if (value || value === 0) {
          var visible = searchFilter(value, _objectSpread({}, node.originNode));
          node.isVisible = visible;

          if (visible) {
            filterNodes.push(node);
            setNodeOriginExpand(node);
          } else {
            removeNodeOriginExpand(node);
          }
        } else {
          node.isVisible = true;
          removeNodeOriginExpand(node);
        }
      } // 显示父级


      for (var _i = 0, _l = filterNodes.length; _i < _l; _i += 1) {
        var _node = filterNodes[_i];
        var np = _node.parent;

        while (np) {
          np.isVisible = true;
          setNodeOriginExpand(np);
          np = np.parent;
        }
      }

      return filterNodes.map(function (node) {
        return _objectSpread({}, node.originNode, {
          pos: node.pos,
          parentNode: getNodeOriginParent(node)
        });
      });
    },
    isExistsKey: function isExistsKey(key) {
      var nodesMap = this.treeStore.nodesMap;
      return key in nodesMap;
    },
    getTreeNodesByKeys: function getTreeNodesByKeys() {
      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var getStoreNode = this.getStoreNode;
      return keys.map(function (key) {
        return getStoreNode(key);
      }).filter(function (node) {
        return !!node;
      });
    },
    getCheckedKeys: function getCheckedKeys() {
      return this.getStoreCheckedKeys();
    },
    getTreeOriginNodes: function getTreeOriginNodes() {
      return this.nodes.map(function (v) {
        return v.originNode;
      });
    },
    rebuildAsyncTree: function rebuildAsyncTree(nodes) {
      var addNodes = this.addNodes,
          updateStoreSelectedKeys = this.updateStoreSelectedKeys,
          updateStoreExpandedKeys = this.updateStoreExpandedKeys,
          updateStoreCheckedKeys = this.updateStoreCheckedKeys; // 清空treeStore中保存的key

      updateStoreSelectedKeys([], null, true);
      updateStoreExpandedKeys([], null, true);
      updateStoreCheckedKeys([], null, true); // 跟异步加载相同的处理逻辑设置首层节点

      this.nodes = addNodes(nodes, null, false);
    }
  }
};